import { apiClient } from '@/lib/api-client';
import type {
  Profile,
  UpdateProfileInput,
} from '../../domain/entities/profile.entity';

export class ProfileApiDatasource {
  /**
   * Usuário corrente pela identidade do token — o back resolve a conta, então
   * não há id de ninguém na URL. `email`/`isVerified` vêm da conta no banco.
   */
  async getMe(): Promise<Profile> {
    const { data } = await apiClient.get<Profile>('/users/me');
    return data;
  }

  /**
   * Mesmo princípio do GET: o back resolve o usuário pelo token, então não há
   * id na URL (o `PATCH /users/:id` foi removido do monolith — qualquer
   * autenticado editava qualquer pessoa). O PATCH devolve só o `User` (sem
   * `email`/`isVerified`), então o retorno é descartado: quem recarrega o
   * estado da tela é a invalidação do `/users/me`.
   */
  async updateMe(payload: UpdateProfileInput): Promise<void> {
    await apiClient.patch('/users/me', payload);
  }
}
